const omitter = <T extends Record<string, any>>(input: T, keys?: string[]): T => {
  const omittedKeys = new Set(['uid', 'createdAt', 'updatedAt', ...(keys ?? [])]);
  return Object.fromEntries(Object.entries(input).filter(([key]) => !omittedKeys.has(key))) as T;
};

export default omitter;
